import React from 'react';
import { motion } from 'framer-motion';
import { SectionHeading } from './SectionHeading';
import { aboutHighlights, site } from '../data/site';
export function About() {
  return <section id="about" className="bg-forest py-24 sm:py-28" data-id="element-9" data-mp="2ttbwpz90oalr">
      <div className="mx-auto max-w-shell px-5 sm:px-8" data-id="element-10" data-mp="2trr3ccyfuxph">
        <div className="grid gap-14 lg:grid-cols-2 lg:items-center" data-id="element-11" data-mp="2ysf2xn0qgmvb">
          <div data-id="element-12" data-mp="33r9i8ezhrtao">
            <SectionHeading eyebrow="About the event" title="Finally, an event designed for ecommerce finance leaders" subtitle="Ecommerce events are built for founders and marketers. If you run finance, you go to learn about someone else’s job. Count Club is 30 people with yours: two days of conversation about the market, the challenges, and the tech, with peers (and new friends) you’ll still be calling in five years." data-id="element-13" data-mp="33rro83byhlvs" />
          </div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.97
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          amount: 0.3
        }} transition={{
          duration: 0.6,
          ease: 'easeOut'
        }} className="relative overflow-hidden rounded-2xl border border-cream/15" data-id="element-14" data-mp="3rgklq48881si">
            <img src={site.aboutImageUrl} alt="A Franklin Barbecue tray of brisket, ribs, sausage, turkey, slaw, potato salad and white bread" className="h-full w-full object-cover" data-id="element-15" data-mp="2crc0piu29cty" />
            <span className="absolute left-5 top-5 rounded-full bg-cream px-4 py-1.5 text-xs font-semibold uppercase tracking-widest2 text-forest" data-id="element-16" data-mp="34jtbmj1n9iju">
              #1 BBQ in America
            </span>
          </motion.div>
        </div>

        <ul className="mt-16 grid gap-px overflow-hidden rounded-2xl border border-forest-line bg-forest-line sm:grid-cols-3" data-id="element-17" data-mp="2qqtwii5rxqct">
          {aboutHighlights.map(item => <li key={item.title} className="bg-forest p-8" data-id="element-18" data-mp="3o7iqjpohfobn">
              <h3 className="font-display text-xl text-cream" data-id="element-19" data-mp="3jdeljbys1qd7">{item.title}</h3>
              <p className="mt-3 text-sm leading-relaxed text-cream-dim" data-id="element-20" data-mp="66vc4vrg3j2x">
                {item.body}
              </p>
            </li>)}
        </ul>
      </div>
    </section>;
}